module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/testimonial/testimonial-style5/testimonial-style5.component.scss
// module id = ./src/app/features/testimonial/testimonial-style5/testimonial-style5.component.scss
// module chunks = main